/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * An object representing a ProgramLabel to be assigned. Provide 'id' to link an existing label, or 'name' to find/create and link. At least one must be present.
 * @export
 * @interface ProgramLabelAssignmentRequest
 */
export interface ProgramLabelAssignmentRequest {
    /**
     * UUID of an existing ProgramLabel to assign. If provided, 'name' is ignored.
     * @type {string}
     * @memberof ProgramLabelAssignmentRequest
     */
    id?: string;
    /**
     * Name of the ProgramLabel. Used if 'id' is not provided. If a label with this name exists for the org, it's used; otherwise, a new ProgramLabel is created.
     * @type {string}
     * @memberof ProgramLabelAssignmentRequest
     */
    name?: string;
}

/**
 * Check if a given object implements the ProgramLabelAssignmentRequest interface.
 */
export function instanceOfProgramLabelAssignmentRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ProgramLabelAssignmentRequestFromJSON(json: any): ProgramLabelAssignmentRequest {
    return ProgramLabelAssignmentRequestFromJSONTyped(json, false);
}

export function ProgramLabelAssignmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProgramLabelAssignmentRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function ProgramLabelAssignmentRequestToJSON(value?: ProgramLabelAssignmentRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

